(function (global, factory) {
    typeof exports === "object" && typeof module !== "undefined"
        ? factory(require("froala-editor"))
        : factory(global.FroalaEditor);
})(this, function (FE) {
    "use strict";
    Object.assign(FE.POPUP_TEMPLATES, {
        "rocketLink.edit": "[_BUTTONS_]",
        "rocketLink.insert": "[_BUTTONS_][_INPUT_LAYER_]",
    }); // Extend defaults.

    Object.assign(FE.DEFAULTS, {
        linkEditButtons: ["linkOpen", "linkStyle", "linkEdit", "linkRemove"],
        linkInsertButtons: ["linkBack", "|", "linkList"],
        linkAttributes: {},
        linkAutoPrefix: "https://",
        linkStyles: {
            "fr-green": "Green",
            "fr-strong": "Thick",
        },
        linkMultipleStyles: true,
        linkConvertEmailAddress: true,
        linkAlwaysBlank: false,
        linkAlwaysNoFollow: false,
        linkNoOpener: true,
        linkNoReferrer: true,
        linkList: [
            {
                id: "jump",
                label: "jump link",
                href: "#",
                rel: null,
            },
            {
                id: "internal",
                label: "internal",
                href: "/",
                rel: null,
            },
            {
                id: "external",
                label: "external",
                href: "",
                target: "_blank",
                rel: "noopener noreferrer nofollow",
            },
            {
                id: "pretty",
                label: "pretty link",
                href: "",
                target: "_blank",
                rel: "sponsored nofollow",
            },
        ],
        linkText: true,
        linkChooseTab: false,
    });

    FE.PLUGINS.rocketLink = function (editor) {
        const $ = editor.$;
        const baseElementId = (type) => `rocket-link-${type}`;
        const elementId = (type) => `rocket-link-${type}-${editor.id}`;
        const apiBase = `${window.location.protocol}//${window.location.host}`;
        const langParam = editor.opts.rocketLinkLanguageId
            ? `?language=${editor.opts.rocketLinkLanguageId}`
            : "";
        const internalDocumentsEndPoint = `${apiBase}/api/documents${langParam}`;
        const affiliateLinkEndPoint = `${apiBase}/api/affiliate-links${langParam}`;
        const fetchConfig = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer eyJpdiI6InZvU2NrUTg5UDF5YjFtU2Y1aDl3U0E9PSIsInZhbHVlIjoiL0E1OTYxYTh3d3VyUXZPUllDV3Q2QnFOQkVVQmlwT3BFbjRKK1BjM0JaST0iLCJtYWMiOiI5ZWFkNDUwODA0ZjU2ODY2MTBjNDA0MTFmNzg5MzFkY2I2YmE3ZDU0NDkzYzFmZDM5Y2FkN2VmODQ1NGNiZTI5In0===`,
            },
        };

        const getInternalLinks = () =>
            fetch(internalDocumentsEndPoint, fetchConfig)
                .then((response) => response.json())
                .then((linkList) =>
                    linkList.map(
                        (l) => `<option value="${l.uri}">${l.name}</option>`
                    )
                );

        const getAffiliateLinks = () =>
            fetch(affiliateLinkEndPoint, fetchConfig)
                .then((response) => response.json())
                .then((linkList) =>
                    linkList.data.map(
                        (l) =>
                            `<option value="${l.full_url_path}">${l.name}</option>`
                    )
                );

        let tabIdx = 0;
        // template for the predefined list of links as datalist
        const getDomainListTpl = (domainList, urlPlaceholder) =>
            `<div class="hidden rocket-link-input" id="${baseElementId(
                "predefined"
            )}">
                    <div class="fr-input-line">
                    <label for="rocket-linklist">Please enter a url</label>
                        <input list="${baseElementId("links")}"
                                id="${baseElementId("list-input")}"
                                name="href"
                                class="fr-link-attr"
                                placeholder="${urlPlaceholder}"/>
                        <datalist id="${baseElementId("links")}">
                        </datalist>
                    </div>
                </div>`;

        // the usual input field template
        const insertLinkTpl = () => {
            let tabIdx = 0;
            let input_layer = `<div class="hidden rocket-link-input" id="${baseElementId(
                "insert"
            )}">
                            <div class="fr-input-line">
                                <input id="fr-link-insert-layer-url-${
                                    editor.id
                                }"
                                name="href"
                                type="text"
                                class="fr-link-attr"
                                placeholder="${editor.language.translate(
                                    "URL"
                                )}" tabIndex="${++tabIdx}"></div>`;

            for (let attr in editor.opts.linkAttributes) {
                if (editor.opts.linkAttributes[attr]) {
                    const placeholder = editor.opts.linkAttributes[attr];
                    input_layer += `<div class="fr-input-line">
                                        <input name="${attr}" type="text" class="fr-link-attr"
                                        placeholder="${editor.language.translate(
                                            placeholder
                                        )}"
                                        tabIndex="${++tabIdx}"></div>`;
                }
            }

            if (editor.opts.linkChooseTab && !editor.opts.linkAlwaysBlank) {
                const checkmark =
                    '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>'; // Image by url layer.
                input_layer += `<div class="fr-checkbox-line">
                                    <span class="fr-checkbox">
                                        <input name="target"
                                               class="fr-link-attr"
                                               data-checked="_blank"
                                               type="checkbox"
                                               id="fr-link-target-${editor.id}"
                                               tabIndex="${++tabIdx}">
                                               <span>${checkmark}</span>
                                  </span>
                                  <label id="fr-label-target-${editor.id}">
                                    ${editor.language.translate(
                                        "Open in new tab"
                                    )}
                                  </label></div>`;
            }

            input_layer += `</div>`;
            return input_layer;
        };

        function get() {
            const $current_image = editor.image ? editor.image.get() : null;
            if (!$current_image && editor.$wp) {
                let c_el = editor.selection.ranges(0).commonAncestorContainer;

                try {
                    if (
                        c_el &&
                        ((c_el.contains && c_el.contains(editor.el)) ||
                            !editor.el.contains(c_el) ||
                            editor.el == c_el)
                    )
                        c_el = null;
                } catch (ex) {
                    c_el = null;
                }

                if (c_el && c_el.tagName === "A") return c_el;
                let s_el = editor.selection.element();
                let e_el = editor.selection.endElement();

                if (s_el.tagName !== "A" && !editor.node.isElement(s_el)) {
                    s_el = $(s_el).parentsUntil(editor.$el, "a").first().get(0);
                }

                if (e_el.tagName !== "A" && !editor.node.isElement(e_el)) {
                    e_el = $(e_el).parentsUntil(editor.$el, "a").first().get(0);
                }

                try {
                    if (
                        e_el &&
                        ((e_el.contains && e_el.contains(editor.el)) ||
                            !editor.el.contains(e_el) ||
                            editor.el == e_el)
                    )
                        e_el = null;
                } catch (ex) {
                    e_el = null;
                }

                try {
                    if (
                        s_el &&
                        ((s_el.contains && s_el.contains(editor.el)) ||
                            !editor.el.contains(s_el) ||
                            editor.el == s_el)
                    )
                        s_el = null;
                } catch (ex) {
                    s_el = null;
                }

                if (e_el && e_el == s_el && e_el.tagName === "A") {
                    // We do not clicking at the end / input of links because in IE the selection is changing shortly after mouseup.
                    // https://jsfiddle.net/jredzam3/
                    if (
                        (editor.browser.msie || editor.helpers.isMobile()) &&
                        (editor.selection.info(s_el).atEnd ||
                            editor.selection.info(s_el).atStart)
                    ) {
                        return null;
                    }

                    return s_el;
                }

                return null;
            } else if (editor.el.tagName === "A") {
                return editor.el;
            } else {
                if (
                    $current_image &&
                    $current_image.get(0).parentNode &&
                    $current_image.get(0).parentNode.tagName === "A"
                ) {
                    return $current_image.get(0).parentNode;
                }
            }
        }

        function allSelected() {
            const $current_image = editor.image ? editor.image.get() : null;
            const selectedLinks = [];

            if ($current_image) {
                if ($current_image.get(0).parentNode.tagName === "A") {
                    selectedLinks.push($current_image.get(0).parentNode);
                }
            } else {
                let range, containerEl, links, linkRange;

                if (editor.win.getSelection) {
                    const sel = editor.win.getSelection();

                    if (sel.getRangeAt && sel.rangeCount) {
                        linkRange = editor.doc.createRange();

                        for (let r = 0; r < sel.rangeCount; ++r) {
                            range = sel.getRangeAt(r);
                            containerEl = range.commonAncestorContainer;

                            if (containerEl && containerEl.nodeType !== 1) {
                                containerEl = containerEl.parentNode;
                            }

                            if (
                                containerEl &&
                                containerEl.nodeName.toLowerCase() === "a"
                            ) {
                                selectedLinks.push(containerEl);
                            } else {
                                links = containerEl.getElementsByTagName("a");

                                for (let i = 0; i < links.length; ++i) {
                                    linkRange.selectNodeContents(links[i]);

                                    if (
                                        linkRange.compareBoundaryPoints(
                                            range.END_TO_START,
                                            range
                                        ) < 1 &&
                                        linkRange.compareBoundaryPoints(
                                            range.START_TO_END,
                                            range
                                        ) > -1
                                    ) {
                                        selectedLinks.push(links[i]);
                                    }
                                }
                            }
                        } // linkRange.detach()
                    }
                } else if (
                    editor.doc.selection &&
                    editor.doc.selection.type !== "Control"
                ) {
                    range = editor.doc.selection.createRange();
                    containerEl = range.parentElement();

                    if (containerEl.nodeName.toLowerCase() === "a") {
                        selectedLinks.push(containerEl);
                    } else {
                        links = containerEl.getElementsByTagName("a");
                        linkRange = editor.doc.body.createTextRange();

                        for (let j = 0; j < links.length; ++j) {
                            linkRange.moveToElementText(links[j]);

                            if (
                                linkRange.compareEndPoints(
                                    "StartToEnd",
                                    range
                                ) > -1 &&
                                linkRange.compareEndPoints(
                                    "EndToStart",
                                    range
                                ) < 1
                            ) {
                                selectedLinks.push(links[j]);
                            }
                        }
                    }
                }
            }

            return selectedLinks;
        }

        function _edit(e) {
            if (editor.core.hasFocus()) {
                _hideEditPopup(); // Do not show edit popup for link when ALT is hit.

                if (
                    e &&
                    e.type === "keyup" &&
                    (e.altKey || e.which === FE.KEYCODE.ALT)
                )
                    return true;
                setTimeout(
                    () => {
                        // No event passed.
                        // Event passed and (left click or other event type).
                        if (
                            !e ||
                            (e && (e.which === 1 || e.type !== "mouseup"))
                        ) {
                            const link = get();
                            const $current_image = editor.image
                                ? editor.image.get()
                                : null;

                            if (link && !$current_image) {
                                if (editor.image) {
                                    const contents = editor.node.contents(link); // https://github.com/froala/wysiwyg-editor/issues/1103

                                    if (
                                        contents.length === 1 &&
                                        contents[0].tagName === "IMG"
                                    ) {
                                        const range = editor.selection.ranges(
                                            0
                                        );

                                        if (
                                            range.startOffset === 0 &&
                                            range.endOffset === 0
                                        ) {
                                            $(link).before(FE.MARKERS);
                                        } else {
                                            $(link).after(FE.MARKERS);
                                        }

                                        editor.selection.restore();
                                        return false;
                                    }
                                }

                                e && e.stopPropagation();
                                _showEditPopup(link);
                            }
                        }
                    },
                    editor.helpers.isIOS() ? 100 : 0
                );
            }
        }

        function _showEditPopup(link) {
            // debugger;

            editor.popups.get("rocketLink.edit") || _initEditPopup();
            const $link = $(link);

            if (!editor.popups.isVisible("rocketLink.edit")) {
                editor.popups.refresh("rocketLink.edit");
            }

            editor.popups.setContainer("rocketLink.edit", editor.$sc);
            const left = $link.offset().left + $link.outerWidth() / 2;
            const top = $link.offset().top + $link.outerHeight();
            editor.popups.show(
                "rocketLink.edit",
                left,
                top,
                $link.outerHeight(),
                true
            );
        }

        function _hideEditPopup() {
            editor.popups.hide("rocketLink.edit");
        }

        function _initEditPopup() {
            // Link buttons.
            let link_buttons = "";

            if (editor.opts.linkEditButtons.length >= 1) {
                if (
                    editor.el.tagName === "A" &&
                    editor.opts.linkEditButtons.indexOf("linkRemove") >= 0
                ) {
                    editor.opts.linkEditButtons.splice(
                        editor.opts.linkEditButtons.indexOf("linkRemove"),
                        1
                    );
                }

                link_buttons = `<div class="fr-buttons">${editor.button.buildList(
                    editor.opts.linkEditButtons
                )}</div>`;
            }

            const template = {
                buttons: link_buttons,
            }; // Set the template in the popup.

            const $popup = editor.popups.create("rocketLink.edit", template);

            if (editor.$wp) {
                editor.events.$on(editor.$wp, "scroll.link-edit", function () {
                    if (get() && editor.popups.isVisible("rocketLink.edit")) {
                        _showEditPopup(get());
                    }
                });
            }

            return $popup;
        }

        /**
         * Hide link insert popup.
         */

        function _refreshInsertPopup() {
            const $popup = editor.popups.get("rocketLink.insert");
            const link = get();

            if (link) {
                const $link = $(link);
                const text_inputs = $popup.find(
                    'input.fr-link-attr[type="text"]'
                );
                const check_inputs = $popup.find(
                    'input.fr-link-attr[type="checkbox"]'
                );
                let i;
                let $input;

                for (i = 0; i < text_inputs.length; i++) {
                    $input = $(text_inputs[i]);
                    $input.val($link.attr($input.attr("name") || ""));
                }

                check_inputs.attr("checked", false);

                for (i = 0; i < check_inputs.length; i++) {
                    $input = $(check_inputs[i]);

                    if (
                        $link.attr($input.attr("name")) ==
                        $input.data("checked")
                    ) {
                        $input.attr("checked", true);
                    }
                }

                $popup
                    .find('input.fr-link-attr[type="text"][name="text"]')
                    .val($link.text());
            } else {
                $popup.find('input.fr-link-attr[type="text"]').val("");
                $popup
                    .find('input.fr-link-attr[type="checkbox"]')
                    .attr("checked", false);
                $popup
                    .find('input.fr-link-attr[type="text"][name="text"]')
                    .val(editor.selection.text());
            }

            $popup.find("input.fr-link-attr").trigger("change");
            const $current_image = editor.image ? editor.image.get() : null;

            if ($current_image) {
                $popup.find('.fr-link-attr[name="text"]').parent().hide();
            } else {
                $popup.find('.fr-link-attr[name="text"]').parent().show();
            }
        }

        function showInsertPopup() {
            const $btn = editor.$tb.find('.fr-command[data-cmd="insertLink"]');
            let $popup =
                editor.popups.get("rocketLink.insert") || _initInsertPopup();

            if (!$popup.hasClass("fr-active")) {
                editor.popups.refresh("rocketLink.insert");
                editor.popups.setContainer(
                    "rocketLink.insert",
                    editor.$tb || editor.$sc
                );

                if ($btn.isVisible()) {
                    const _editor$button$getPos = editor.button.getPosition(
                            $btn
                        ),
                        left = _editor$button$getPos.left,
                        top = _editor$button$getPos.top;

                    editor.popups.show(
                        "rocketLink.insert",
                        left,
                        top,
                        $btn.outerHeight()
                    );
                } else {
                    editor.position.forSelection($popup);
                    editor.popups.show("rocketLink.insert");
                }
            }
        }

        function _initInsertPopup(delayed) {
            if (delayed) {
                editor.popups.onRefresh(
                    "rocketLink.insert",
                    _refreshInsertPopup
                );
                return true;
            } // Image buttons.

            let buttons = "";

            if (editor.opts.linkInsertButtons.length >= 1) {
                buttons = `<div class="fr-buttons fr-tabs">
                                ${editor.button.buildList(
                                    editor.opts.linkInsertButtons
                                )}
                           </div>`;
            }
            const linkTextInput = editor.opts.linkText
                ? `<div class="fr-input-line">
                                    <input id="fr-link-insert-layer-text"
                                            name="text"
                                            type="text"
                                            class="fr-link-attr"
                                            placeholder="${editor.language.translate(
                                                "Text"
                                            )}" tabIndex="${++tabIdx}">
                </div>`
                : "";

            const template = {
                buttons: buttons,
                input_layer: `<div class="rocket-link-container" id="rocket-link-input-container">
                                <div class="fr-link-insert-layer fr-layer fr-active">
                                    ${linkTextInput}
                                    ${insertLinkTpl(editor)}
                                    ${getDomainListTpl([], "URL")}
                                    <div class="fr-action-buttons">
                                        <button class="fr-command fr-submit"
                                                role="button"
                                                data-cmd="linkInsert"
                                                tabIndex="${++tabIdx}" type="button">
                                            ${editor.language.translate(
                                                "Insert"
                                            )}
                                        </button>
                                    </div>
                                </div>
                             </div>`,
            }; // Set the template in the popup.

            const $popup = editor.popups.create("rocketLink.insert", template);

            if (editor.$wp) {
                editor.events.$on(
                    editor.$wp,
                    "scroll.link-insert",
                    function () {
                        const $current_image = editor.image
                            ? editor.image.get()
                            : null;

                        if (
                            $current_image &&
                            editor.popups.isVisible("rocketLink.insert")
                        ) {
                            imageLink();
                        }

                        if (
                            get &&
                            editor.popups.isVisible("rocketLink.insert")
                        ) {
                            update();
                        }
                    }
                );
            }

            return $popup;
        }

        function remove() {
            const link = get();
            const $current_image = editor.image ? editor.image.get() : null;
            if (editor.events.trigger("link.beforeRemove", [link]) === false)
                return false; // https://github.com/froala-labs/froala-editor-js-2/issues/3110
            // Check if image has caption and handle the unlink to retain caption

            if ($current_image && link) {
                if (editor.image.hasCaption()) {
                    $current_image.addClass("img-link-caption");
                    $(link).replaceWith($(link).html());
                    const newImg = document.querySelectorAll(
                        "img.img-link-caption"
                    );
                    editor.image.edit($(newImg[0]));
                    $(newImg[0]).removeClass("img-link-caption");
                } else {
                    $current_image.unwrap();
                    editor.image.edit($current_image);
                }
            } else if (link) {
                editor.selection.save();
                $(link).replaceWith($(link).html());
                editor.selection.restore();

                _hideEditPopup();
            }
        }

        function _init() {
            // Edit on keyup.
            editor.events.on("keyup", function (e) {
                if (e.which !== FE.KEYCODE.ESC) {
                    _edit(e);
                }
            });
            editor.events.on("window.mouseup", _edit); // Do not follow links when edit is disabled.

            editor.events.$on(editor.$el, "click", "a", function (e) {
                if (editor.edit.isDisabled()) {
                    e.preventDefault();
                }
            });

            if (editor.helpers.isMobile()) {
                editor.events.$on(editor.$doc, "selectionchange", _edit);
            }

            _initInsertPopup(true); // Init on link.

            if (editor.el.tagName === "A") {
                editor.$el.addClass("fr-view");
            } // Hit ESC when focus is in link edit popup.

            editor.events.on(
                "toolbar.esc",
                function () {
                    if (editor.popups.isVisible("rocketLink.edit")) {
                        editor.events.disableBlur();
                        editor.events.focus();
                        return false;
                    }
                },
                true
            );
        }

        function usePredefined(val) {
            const link = editor.opts.linkList[val];
            const $popup = editor.popups.get("rocketLink.insert");
            $(".rocket-link-input", $popup).addClass("hidden");

            $(`label[for="fr-link-insert-layer-text"]`).html(
                link.label.toUpperCase()
            );

            ["target", "rel"].forEach((a) =>
                link[a] ? ($popup[a] = link[a]) : delete $popup[a]
            );

            // set linklist from api call
            if (["internal", "pretty"].indexOf(link.id) >= 0) {
                $(`#${baseElementId("predefined")}`, $popup).removeClass(
                    "hidden"
                );
                $(`#${baseElementId("list-input")}`).val("");
                (link.id === "internal"
                    ? getInternalLinks()
                    : getAffiliateLinks()
                ).then((linkList) =>
                    $(`#${baseElementId("links")}`, $popup).html(
                        linkList.join()
                    )
                );
            } else {
                $(`div[id^=${baseElementId("insert")}]`, $popup).removeClass(
                    "hidden"
                ); //temp placeholder
                const text_inputs = $popup.find(
                    'input.fr-link-attr[type="text"]'
                );
                const check_inputs = $popup.find(
                    'input.fr-link-attr[type="checkbox"]'
                );
                let $input;
                let i; // Add rel attribute to the popup if it exists

                for (i = 0; i < text_inputs.length; i++) {
                    $input = $(text_inputs[i]);
                    if (link[$input.attr("name")]) {
                        $input.val(link[$input.attr("name")]); // Mark the input box as non empty for transition
                        $input.toggleClass("fr-not-empty", true);
                    } else if ($input.attr("name") !== "text") {
                        $input.val("");
                    }
                }

                for (i = 0; i < check_inputs.length; i++) {
                    $input = $(check_inputs[i]);
                    $input.attr(
                        "checked",
                        $input.data("checked") === link[$input.attr("name")]
                    );
                }
            }

            editor.accessibility.focusPopup($popup);
        }

        function insertCallback() {
            const $popup = editor.popups.get("rocketLink.insert");
            const text_inputs = $popup.find('input.fr-link-attr[type="text"]');
            const check_inputs = $popup.find(
                'input.fr-link-attr[type="checkbox"]'
            );

            const href = (
                editor
                    .$(
                        '.rocket-link-input:not(.hidden) input[name="href"]',
                        $popup
                    )
                    .val() || ""
            ).trim();
            const text = (
                editor.$('input[name="text"]', $popup).val() || ""
            ).trim();
            const attrs = {};
            let $input;
            let i;

            const linkLabel = $popup.find(
                `label[for="${$(text_inputs[0]).attr("id")}"]`
            );
            linkLabel[0].innerHTML = "URL";

            for (i = 0; i < text_inputs.length; i++) {
                $input = $(text_inputs[i]);

                if (["href", "text"].indexOf($input.attr("name")) < 0) {
                    attrs[$input.attr("name")] = $input.val();
                }
            }

            for (i = 0; i < check_inputs.length; i++) {
                $input = $(check_inputs[i]);

                if ($input.is(":checked")) {
                    attrs[$input.attr("name")] = $input.data("checked");
                } else {
                    attrs[$input.attr("name")] =
                        $input.data("unchecked") || null;
                }
            }

            // setting target and rel
            ["target", "rel"]
                .filter((att) => !!$popup[att])
                .forEach((att) => (attrs[att] = $popup[att]));

            const t = editor.helpers.scrollTop();
            insert(href, text, attrs);
            editor
                .$('.rocket-link-input:not(.hidden) input[name="href"]', $popup)
                .val("");
            $(editor.o_win).scrollTop(t);
        }

        function _split() {
            if (!editor.selection.isCollapsed()) {
                editor.selection.save();
                let markers = editor.$el
                    .find(".fr-marker")
                    .addClass("fr-unprocessed")
                    .toArray();

                while (markers.length) {
                    const $marker = $(markers.pop());
                    $marker.removeClass("fr-unprocessed"); // Get deepest parent.

                    const deep_parent = editor.node.deepestParent(
                        $marker.get(0)
                    );

                    if (deep_parent) {
                        let node = $marker.get(0);
                        let close_str = "";
                        let open_str = "";

                        do {
                            node = node.parentNode;

                            if (!editor.node.isBlock(node)) {
                                close_str =
                                    close_str +
                                    editor.node.closeTagString(node);
                                open_str =
                                    editor.node.openTagString(node) + open_str;
                            }
                        } while (node != deep_parent);

                        const marker_str =
                            editor.node.openTagString($marker.get(0)) +
                            $marker.html() +
                            editor.node.closeTagString($marker.get(0));
                        $marker.replaceWith('<span id="fr-break"></span>');
                        let h = deep_parent.outerHTML; //  https://github.com/froala/wysiwyg-editor/issues/3048

                        h = h.replace(
                            /<span id="fr-break"><\/span>/g,
                            close_str + marker_str + open_str
                        );
                        h = h.replace(open_str + close_str, "");
                        deep_parent.outerHTML = h;
                    }

                    markers = editor.$el
                        .find(".fr-marker.fr-unprocessed")
                        .toArray();
                }

                editor.html.cleanEmptyTags();
                editor.selection.restore();
            }
        }

        /**
         * Insert link into the editor.
         */

        function insert(href, text, attrs) {
            if (typeof attrs == "undefined") attrs = {};
            if (
                editor.events.trigger("link.beforeInsert", [
                    href,
                    text,
                    attrs,
                ]) === false
            )
                return false; // Get image if we have one selected.

            const $current_image = editor.image ? editor.image.get() : null;

            if (!$current_image && editor.el.tagName !== "A") {
                editor.selection.restore();
                editor.popups.hide("rocketLink.insert");
            } else if (editor.el.tagName === "A") {
                editor.$el.focus();
            }

            const original_href = href; // Convert email address.

            if (editor.opts.linkConvertEmailAddress) {
                if (editor.helpers.isEmail(href) && !/^mailto:.*/i.test(href)) {
                    href = `mailto:${href}`;
                }
            } // Check if is local path.

            const local_path = /^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i; // Add autoprefix.

            if (
                editor.opts.linkAutoPrefix !== "" &&
                !new RegExp(
                    "^(" + FE.LinkProtocols.join("|") + "):.",
                    "i"
                ).test(href) &&
                !/^data:image.*/i.test(href) &&
                !/^(https?:|ftps?:|file:|)\/\//i.test(href) &&
                !local_path.test(href)
            ) {
                // Do prefix only if starting character is not absolute.
                if (
                    ["/", "{", "[", "#", "(", "."].indexOf((href || "")[0]) < 0
                ) {
                    href = editor.opts.linkAutoPrefix + href;
                }
            } // Sanitize the URL.

            href = editor.helpers.sanitizeURL(href); // Default attributs.

            if (editor.opts.linkAlwaysBlank) attrs.target = "_blank";
            if (editor.opts.linkAlwaysNoFollow) attrs.rel = "nofollow";

            if (editor.helpers.isEmail(original_href)) {
                attrs.target = null;
                attrs.rel = null;
            } // https://github.com/froala/wysiwyg-editor/issues/1576.

            text = text || "";

            if (href === editor.opts.linkAutoPrefix) {
                const $popup = editor.popups.get("rocketLink.insert");
                $popup.find('input[name="href"]').addClass("fr-error");
                editor.events.trigger("link.bad", [original_href]);
                return false;
            } // Check if we have selection only in one link.

            let link = get();
            let $link;

            if (link) {
                $link = $(link);
                $link.attr("href", href); // Change text if it is different.

                if (
                    text.length > 0 &&
                    $link.text() !== text &&
                    !$current_image
                ) {
                    let child = $link.get(0);

                    while (
                        child.childNodes.length === 1 &&
                        child.childNodes[0].nodeType === Node.ELEMENT_NODE
                    ) {
                        child = child.childNodes[0];
                    }

                    $(child).text(text);
                }

                if (!$current_image) {
                    $link.prepend(FE.START_MARKER).append(FE.END_MARKER);
                } // Set attributes.
                // https://github.com/froala-labs/froala-editor-js-2/issues/2023

                for (let prop in attrs) {
                    if (!attrs[prop]) {
                        $link.removeAttr(prop);
                    } else {
                        $link.attr(prop, attrs[prop]);
                    }
                }

                if (!$current_image) {
                    editor.selection.restore();
                }
            } else {
                // We don't have any image selected.
                if (!$current_image) {
                    // Remove current links.
                    editor.format.remove("a"); // Nothing is selected.

                    if (editor.selection.isCollapsed()) {
                        text = text.length === 0 ? original_href : text;
                        const linkText = text
                            .replace(/&/g, "&amp;")
                            .replace(/</, "&lt;", ">", "&gt;");
                        editor.html.insert(
                            `<a href="${href}">${FE.START_MARKER}${linkText}${FE.END_MARKER}</a>`
                        );
                        editor.selection.restore();
                    } else {
                        if (
                            text.length > 0 &&
                            text != editor.selection.text().replace(/\n/g, "")
                        ) {
                            editor.selection.remove();
                            editor.html.insert(
                                `<a href="${href}">
                                    ${FE.START_MARKER}
                                    ${text.replace(/&/g, "&amp;")}
                                    ${FE.END_MARKER}</a>`
                            );
                            editor.selection.restore();
                        } else {
                            _split(); // Add link.
                            editor.format.apply("a", {
                                href: href,
                            });
                        }
                    }
                } else {
                    // Just wrap current image with a link.
                    $current_image.wrap(`<a href="${href}"></a>`);

                    if (editor.image.hasCaption()) {
                        $current_image
                            .parent()
                            .append(
                                $current_image
                                    .parents(".fr-img-caption")
                                    .find(".fr-inner")
                            );
                    }
                } // Set attributes.

                const links = allSelected();

                for (let i = 0; i < links.length; i++) {
                    $link = $(links[i]);
                    $link.attr(attrs);
                    $link.removeAttr("_moz_dirty");
                } // Show link edit if only one link.

                if (links.length === 1 && editor.$wp && !$current_image) {
                    $(links[0]).prepend(FE.START_MARKER).append(FE.END_MARKER);
                    editor.selection.restore();
                }
            } // Hide popup and try to edit.

            if (!$current_image) {
                _edit();
            } else {
                const $pop = editor.popups.get("rocketLink.insert");

                if ($pop) {
                    $pop.find("input:focus").blur();
                }

                editor.image.edit($current_image);
            }
        }

        function update() {
            _hideEditPopup();

            const link = get();

            if (link) {
                editor.popups.get("rocketLink.insert") || _initInsertPopup();

                if (!editor.popups.isVisible("rocketLink.insert")) {
                    editor.popups.refresh("rocketLink.insert");
                    editor.selection.save();

                    if (editor.helpers.isMobile()) {
                        editor.events.disableBlur();
                        editor.$el.blur();
                        editor.events.enableBlur();
                    }
                }

                editor.popups.setContainer("rocketLink.insert", editor.$sc);
                const $ref =
                    (editor.image ? editor.image.get() : null) || $(link);
                const left = $ref.offset().left + $ref.outerWidth() / 2;
                const top = $ref.offset().top + $ref.outerHeight();
                editor.popups.show(
                    "rocketLink.insert",
                    left,
                    top,
                    $ref.outerHeight(),
                    true
                );
            }
        }

        function back() {
            const $current_image = editor.image ? editor.image.get() : null;

            if (!$current_image) {
                editor.events.disableBlur();
                editor.selection.restore();
                editor.events.enableBlur();
                const link = get();

                if (link && editor.$wp) {
                    editor.selection.restore();

                    _hideEditPopup();

                    _edit();
                } else if (editor.el.tagName === "A") {
                    editor.$el.focus();

                    _edit();
                } else {
                    editor.popups.hide("rocketLink.insert");
                    editor.toolbar.showInline();
                }
            } else {
                editor.image.back();
            }
        }

        function imageLink() {
            let $el = editor.image ? editor.image.getEl() : null;

            if ($el) {
                editor.popups.get("rocketLink.insert") || _initInsertPopup();

                if (editor.image.hasCaption()) {
                    $el = $el.find(".fr-img-wrap");
                }

                _refreshInsertPopup(true);

                editor.popups.setContainer("rocketLink.insert", editor.$sc);
                const left = $el.offset().left + $el.outerWidth() / 2;
                const top = $el.offset().top + $el.outerHeight();
                editor.popups.show(
                    "rocketLink.insert",
                    left,
                    top,
                    $el.outerHeight(),
                    true
                );
            }
        }

        /**
         * Apply specific style.
         */

        function applyStyle(val, linkStyles, multipleStyles) {
            if (typeof multipleStyles == "undefined")
                multipleStyles = editor.opts.linkMultipleStyles;
            if (typeof linkStyles == "undefined")
                linkStyles = editor.opts.linkStyles;
            const link = get();
            if (!link) return false; // Remove multiple styles.

            if (!multipleStyles) {
                const styles = Object.keys(linkStyles);
                styles.splice(styles.indexOf(val), 1);
                $(link).removeClass(styles.join(" "));
            }

            $(link).toggleClass(val);

            _edit();
        }

        return {
            _init,
            remove,
            showInsertPopup,
            usePredefined,
            insertCallback,
            insert,
            update,
            get,
            allSelected,
            back,
            imageLink,
            applyStyle,
        };
    }; // Register the link command.

    FE.DefineIcon("rocketLink", {
        NAME: "link",
        SVG_KEY: "insertLink",
    });
    FE.RegisterShortcut(FE.KEYCODE.K, "rocketLink", null, "K");
    FE.RegisterCommand("rocketLink", {
        title: "Insert rocket Link",
        undo: false,
        focus: false,
        refreshOnCallback: false,
        popup: true,
        callback: function callback() {
            if (!this.popups.isVisible("rocketLink.insert")) {
                this.rocketLink.showInsertPopup();
            } else {
                if (this.$el.find(".fr-marker").length) {
                    this.events.disableBlur();
                    this.selection.restore();
                }

                this.popups.hide("rocketLink.insert");
            }
        },
        plugin: "rocketLink",
    });
    FE.DefineIcon("linkOpen", {
        NAME: "external-link",
        FA5NAME: "external-link-alt",
        SVG_KEY: "openLink",
    });
    FE.RegisterCommand("linkOpen", {
        title: "Open Link",
        undo: false,
        refresh: function refresh($btn) {
            const link = this.rocketLink.get();
            if (link) {
                $btn.removeClass("fr-hidden");
            } else {
                $btn.addClass("fr-hidden");
            }
        },
        callback: function callback() {
            const link = this.rocketLink.get();

            if (link) {
                if (link.href.indexOf("mailto:") !== -1) {
                    this.o_win.open(link.href).close();
                } else {
                    // Setting the context of the opening link to _self for opening it within window
                    if (!link.target) {
                        link.target = "_self";
                    }

                    if (this.browser.msie || this.browser.edge) {
                        // noopener is not supported in IE and EDGE
                        this.o_win.open(link.href, link.target);
                    } else {
                        this.o_win.open(link.href, link.target, "noopener");
                    }
                }

                this.popups.hide("rocketLink.edit");
            }
        },
        plugin: "rocketLink",
    });
    FE.DefineIcon("linkEdit", {
        NAME: "edit",
        SVG_KEY: "edit",
    });
    FE.RegisterCommand("linkEdit", {
        title: "Edit Link",
        undo: false,
        refreshAfterCallback: false,
        popup: true,
        callback: function callback() {
            this.rocketLink.update();
        },
        refresh: function refresh($btn) {
            const link = this.rocketLink.get();
            if (link) {
                $btn.removeClass("fr-hidden");
            } else {
                $btn.addClass("fr-hidden");
            }
        },
        plugin: "rocketLink",
    });
    FE.DefineIcon("linkRemove", {
        NAME: "unlink",
        SVG_KEY: "unlink",
    });
    FE.RegisterCommand("linkRemove", {
        title: "Unlink",
        callback: function callback() {
            this.rocketLink.remove();
        },
        refresh: function refresh($btn) {
            const link = this.rocketLink.get();

            if (link) {
                $btn.removeClass("fr-hidden");
            } else {
                $btn.addClass("fr-hidden");
            }
        },
        plugin: "rocketLink",
    });
    FE.DefineIcon("linkBack", {
        NAME: "arrow-left",
        SVG_KEY: "back",
    });
    FE.RegisterCommand("linkBack", {
        title: "Back",
        undo: false,
        focus: false,
        back: true,
        refreshAfterCallback: false,
        callback: function callback() {
            this.rocketLink.back();
        },
        refresh: function refresh($btn) {
            const link = this.rocketLink.get() && this.doc.hasFocus();
            const $current_image = this.image ? this.image.get() : null;

            if (!$current_image && !link && !this.opts.toolbarInline) {
                $btn.addClass("fr-hidden");
                $btn.next(".fr-separator").addClass("fr-hidden");
            } else {
                $btn.removeClass("fr-hidden");
                $btn.next(".fr-separator").removeClass("fr-hidden");
            }
        },
        plugin: "rocketLink",
    });
    FE.DefineIcon("linkList", {
        NAME: "search",
        SVG_KEY: "search",
    });
    FE.RegisterCommand("linkList", {
        title: "Choose Link type",
        type: "dropdown",
        focus: false,
        undo: false,
        refreshAfterCallback: false,
        html: function html() {
            let c =
                '<ul id="rocket-link-types" class="fr-dropdown-list" role="presentation">';
            const options = this.opts.linkList;

            for (let i = 0; i < options.length; i++) {
                c += `<li role="presentation">
    <a class="fr-command" tabIndex="-1" role="option" data-cmd="linkList" data-param1="${i}">
        ${options[i].label}
    </a>
    </li>`;
            }

            c += "</ul>";
            return c;
        },
        callback: function callback(cmd, val) {
            this.rocketLink.usePredefined(val);
        },
        plugin: "rocketLink",
    });
    FE.RegisterCommand("linkInsert", {
        focus: false,
        refreshAfterCallback: false,
        callback: function callback() {
            this.rocketLink.insertCallback();
        },
        refresh: function refresh($btn) {
            const link = this.rocketLink.get();
            if (link) {
                $btn.text(this.language.translate("Update"));
            } else {
                $btn.text(this.language.translate("Insert"));
            }
        },
        plugin: "rocketLink",
    }); // Image link.

    FE.DefineIcon("imageLink", {
        NAME: "ROCKETLink",
        SVG_KEY: "insertLink",
    });
    FE.RegisterCommand("imageLink", {
        title: "Insert Link",
        undo: false,
        focus: false,
        popup: true,
        callback: function callback() {
            this.rocketLink.imageLink();
        },
        refresh: function refresh($btn) {
            const link = this.rocketLink.get();
            let $prev;

            if (link) {
                $prev = $btn.prev();

                if ($prev.hasClass("fr-separator")) {
                    $prev.removeClass("fr-hidden");
                }

                $btn.addClass("fr-hidden");
            } else {
                $prev = $btn.prev();

                if ($prev.hasClass("fr-separator")) {
                    $prev.addClass("fr-hidden");
                }

                $btn.removeClass("fr-hidden");
            }
        },
        plugin: "rocketLink",
    }); // Link styles.

    FE.DefineIcon("linkStyle", {
        NAME: "magic",
        SVG_KEY: "linkStyles",
    });
    FE.RegisterCommand("linkStyle", {
        title: "Style",
        type: "dropdown",
        html: function html() {
            let c = '<ul class="fr-dropdown-list" role="presentation">';
            const options = this.opts.linkStyles;

            for (let cls in options) {
                if (options[cls]) {
                    c += `<li role="presentation">
                            <a class="fr-command"
                                tabIndex="-1"
                                role="option"
                                data-cmd="linkStyle"
                                data-param1="${cls}">${this.language.translate(
                        options[cls]
                    )}</a>
                           </li>`;
                }
            }

            c += "</ul>";
            return c;
        },
        callback: function callback(cmd, val) {
            this.rocketLink.applyStyle(val);
        },
        refreshOnShow: function refreshOnShow($btn, $dropdown) {
            const $ = this.$;
            const link = this.rocketLink.get();
            if (link) {
                const $link = $(link);
                $dropdown.find(".fr-command").each(function () {
                    const cls = $(this).data("param1");
                    const active = $link.hasClass(cls);
                    $(this)
                        .toggleClass("fr-active", active)
                        .attr("aria-selected", active);
                });
            }
        },
        refresh: function refresh($btn) {
            const link = this.rocketLink.get();
            if (link) {
                $btn.removeClass("fr-hidden");
            } else {
                $btn.addClass("fr-hidden");
            }
        },
        plugin: "rocketLink",
    });
});
//# sourceMappingURL=link.js.map
